import { breakInfinityUpgrades } from "./break-infinity-upgrades";
import { infinityUpgrades } from "./infinity-upgrades";

export const infinity = {
  upgrades: infinityUpgrades,
  breakUpgrades: breakInfinityUpgrades,
};
